import UcatLandingPage from './UcatLandingPage';
export default UcatLandingPage;
